import { render, staticRenderFns } from "./SetCommission.vue?vue&type=template&id=782a2807&scoped=true"
import script from "./SetCommission.vue?vue&type=script&lang=js"
export * from "./SetCommission.vue?vue&type=script&lang=js"
import style0 from "./SetCommission.vue?vue&type=style&index=0&id=782a2807&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782a2807",
  null
  
)

export default component.exports